import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Center, Flex, Text } from '@chakra-ui/react';
import { Logo, theme } from '@whitbread-eos/atoms';
import { useStaticHotelInformation } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var HubZipNotice = _ref => {
  var srcHubLogo = _ref.srcHubLogo;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useStaticHotelInform = useStaticHotelInformation(),
    brand = _useStaticHotelInform.brand,
    isLoading = _useStaticHotelInform.isLoading,
    isError = _useStaticHotelInform.isError,
    error = _useStaticHotelInform.error;
  if (isLoading) {
    return _jsx(Text, {
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isError) {
    return _jsx(Text, {
      children: error.message
    });
  }
  if (!brand || !['HUB', 'ZIP'].includes(brand)) {
    return null;
  }
  var notice = {
    title: brand === 'HUB' ? t('hoteldetails.hub.alertText') : t('hoteldetails.priceFighter.alertText'),
    subtitle: t('hoteldetails.hub.tagline1'),
    description: t('hoteldetails.hub.tagline2')
  };
  var titleStyles = {
    bg: brand === 'HUB' ? theme.colors.hubPrimary : theme.colors.zipPrimary,
    py: '.3125rem',
    mb: 'lg',
    color: brand === 'HUB' ? 'darkGrey1' : 'white',
    fontWeight: brand === 'HUB' ? 'bold' : '',
    lineHeight: 3,
    mx: {
      mobile: '-1.5rem',
      lg: '0'
    },
    fontSize: 'md'
  };
  var subtitleStyles = {
    fontSize: 'md',
    fontWeight: '600',
    mb: 'sm',
    color: 'darkGrey1',
    lineHeight: 3
  };
  var descriptionStyles = {
    fontSize: 'md',
    lineHeight: 3,
    color: 'darkGrey1'
  };
  return _jsxs(Box, {
    mt: "md",
    "data-testid": "hub-zip-notice",
    children: [_jsx(Center, _objectSpread(_objectSpread({}, titleStyles), {}, {
      "data-testid": "hdp_hubZipNoticeTitle",
      children: notice.title
    })), _jsxs(Flex, {
      direction: {
        base: 'column',
        sm: 'inherit'
      },
      alignItems: {
        base: 'baseline',
        sm: 'center'
      },
      mb: {
        base: 12,
        sm: 0
      },
      children: [_jsx(Box, {
        mb: {
          base: 6,
          sm: 0
        },
        children: _jsx(Logo, {
          variant: brand === 'HUB' ? 'hub' : 'zip',
          transform: "scale(1)",
          src: srcHubLogo
        })
      }), _jsxs(Flex, {
        direction: "column",
        pl: {
          sm: '3.125rem'
        },
        "data-testid": "hdp_hubZipNoticeInformation",
        children: [_jsx(Text, _objectSpread(_objectSpread({}, subtitleStyles), {}, {
          children: notice.subtitle
        })), _jsx(Text, _objectSpread(_objectSpread({}, descriptionStyles), {}, {
          children: notice.description
        }))]
      })]
    })]
  });
};